import { connect } from 'react-redux'

import {
  getIdentityCanRepeatActivity,
  getIdentityActiveProTrackWithLevelName,
  hasAction,
} from 'store/entities/identity/selectors'
import { activityIsRepeating } from 'store/entities/activity/selectors'
import { COMMIT } from 'app/constants/identityActions'
import { getUIWindowSizesWidth } from 'store/entities/ui/selectors'

import ActivityHeader from './ActivityHeader'

const mapStateToProps = state => {
  const windowWidth = getUIWindowSizesWidth(state)
  const canRepeatActivity = getIdentityCanRepeatActivity(state)
  const isActivityRepeating = activityIsRepeating(state)
  const notCommitted = hasAction(state)(COMMIT)
  const showRepeatButton = canRepeatActivity && (!notCommitted || isActivityRepeating)
  return {
    proTrackNameWithLevelName: getIdentityActiveProTrackWithLevelName(state),
    showRepeatButton,
    windowWidth,
  }
}

export default connect(mapStateToProps)(ActivityHeader)
